import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  GetOpportunityList: (cusId) => createAction(constants.OPPORTUNITY_LIST, { cusId }),
  GetLowPerformanceKeywords: (cusId, date) => createAction(constants.LOW_PERFORMANCE_KEYWORDS, { cusId, date }),
};

export default actions;
